import Vue from 'vue' // 引入Vue
import VueI18n from 'vue-i18n' // 引入i18n
import locale from 'element-ui/lib/locale' // 引入element 国际化配置

import CN from './zh-CN.js' // 中文文件
import US from './en-US.js' // 英文文件
import TW from './zh-TW.js' // 中文繁体
import JA from './ja.js' // 日语
import DE from './de.js' // 德语
import KO from './ko.js' // 韩语
import VI from './vi.js' // 越南

Vue.use(VueI18n)
// 创建实例并且挂在自定义语言包
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh', // 默认语言为中文
  messages: {
    zh: CN,
    en: US,
    zh_TW: TW,
    ja: JA,
    de: DE,
    ko: KO,
    vi: VI
  }
})
window._$i18n = i18n
locale.i18n((key, value) => i18n.t(key, value)) // 把element 的语言包挂在到i18n中
export default i18n
